import { GoogleUserProfile } from "@/shared/types";
import { createContext } from "react";
import { AuthGrant } from "@/app/store/useAuthStore";

export interface AuthContextType {
  user: GoogleUserProfile | null;
  grant: AuthGrant;

  isAuthenticated: boolean;
  isLoading: boolean;


  loginWithGoogleCallBack: (credential: string) => Promise<void>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
